import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';

const ENCRYPTION_KEY = process.env.NEXT_PUBLIC_COOKIE_ENCRYPTION_KEY || 'your-fallback-key';

class CookieProvider {
  private encrypt(value: string): string {
    return CryptoJS.AES.encrypt(value, ENCRYPTION_KEY).toString();
  }

  private decrypt(value: string): string {
    const bytes = CryptoJS.AES.decrypt(value, ENCRYPTION_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
  }

  set(key: string, value: any, options?: Cookies.CookieAttributes): void {
    const stringValue = typeof value === 'string' ? value : JSON.stringify(value);
    const encryptedValue = this.encrypt(stringValue);
    Cookies.set(key, encryptedValue, {
      ...options,
      // secure: true, // only to work on localhost...
      // sameSite: 'strict', // only to work on localhost...
      sameSite: 'lax', // only work on local network 192....
      path: '/',
    });
  }


  // new code for prod
  // set(key: string, value: any, options?: Cookies.CookieAttributes): void {
  //   const stringValue = typeof value === 'string' ? value : JSON.stringify(value);
  //   const encryptedValue = this.encrypt(stringValue);
  //   Cookies.set(key, encryptedValue, {
  //     ...options,
  //     domain: '.emediskill.com',  // ✅ Share across subdomains
  //     secure: true,               // ✅ HTTPS required
  //     sameSite: 'none',           // ✅ Allow cross-subdomain
  //     path: '/'                   // ✅ (optional) ensure cookie is sent to all routes
  //   });
  // }


  get(key: string): any {
    const encryptedValue = Cookies.get(key);
    if (!encryptedValue) return null;

    try {
      const decryptedValue = this.decrypt(encryptedValue);
      try {
        return JSON.parse(decryptedValue);
      } catch {
        return decryptedValue;
      }
    } catch (error) {
      console.error('Cookie decryption failed:', error);
      return null;
    }
  }

  remove(key: string, options?: Cookies.CookieAttributes): void {
    Cookies.remove(key, {
      ...options,
      secure: true,
      sameSite: 'strict'
    });
  }

  // new code
  // remove(key: string, options?: Cookies.CookieAttributes): void {
  //   Cookies.remove(key, {
  //     ...options,
  //     domain: '.emediskill.com',  // ✅ Required to delete shared cookie
  //     secure: true,
  //     sameSite: 'none',
  //     path: '/'
  //   });
  // }

  // Helper methods for common operations
  getAuthToken(): string | null {
    return this.get('authToken');
  }

  getLoginToken(): string | null {
    return this.get('loginToken');
  }
  getLoginRefreshToken(): string | null {
    return this.get('loginRefreshToken');
  }

  getRefreshToken(): string | null {
    return this.get('refreshToken');
  }

  getUserData(): any | null {
    return this.get('userData');
  }

  getAuthFlowState(): string | null {
    return this.get('authFlowState');
  }

  clearAuthData(): void {
    this.remove('authToken');
    this.remove('refreshToken');
    this.remove('userData');
    this.remove('isOtpSent');
    this.remove('phoneNumber');
    this.remove('countryCode');
  }

  clearLoginData(): void {
    this.remove('loginToken');
    this.remove('loginRefreshToken');
    this.remove('isOtpSent');
    this.remove('authFlowState');
    this.remove('countryCode');
    this.remove('phoneNumber');
    this.remove('loginData');
  }
}

export const cookieProvider = new CookieProvider();